import FastForward from '@mui/icons-material/FastForward';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function FastForwardIcon(props: FixMe) {
  return <FastForward {...props} />;
}

export default FastForwardIcon;
